"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../../store/store");
function getClauseIdsForSectionType(sectionType) {
    switch (sectionType) {
        case 'conditional':
            return store_1.default.inboxRulesEditState.conditionalClauseIds;
        case 'action':
            return store_1.default.inboxRulesEditState.actionClauseIds;
        case 'exception':
            return store_1.default.inboxRulesEditState.exceptionClauseIds;
        default:
            throw new Error('Cannot get clause ids for a section type that does not exist');
    }
}
exports.default = getClauseIdsForSectionType;
//# sourceMappingURL=getClauseIdsForSectionType.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/getClauseIdsForSectionType.js
// module id = 3175
// module chunks = 2 90